<template>
  <div class="hallway">
    <div class="message">
      <p v-if="organizerName">{{ $t('hallway.waitOrganizerName', {organizerName}) }}</p>
      <p v-else>{{ $t('hallway.waitOrganizer') }}</p>
    </div>

    <div v-if="waitUntil">
      <p class="starts-in">{{ $t('hallway.startsIn') }}</p>
      <p class="countdown">{{ displayCountdown }}</p>
    </div>
  </div>
</template>

<script>
const Hallway = {
  name: 'Hallway',

  data() {
    return {
      timeoutId: null,
      countdown: 0
    };
  },

  computed: {
    organizerName() {
      const webinarInfo = this.$store.state.g2wWebinar.webinarInfo;
      return webinarInfo && webinarInfo.organizerName;
    },

    timeOffsetMS() {
      const { joinInfo } = this.$store.state.g2wSession;
      return joinInfo && joinInfo.timeOffsetMS;
    },

    waitUntil() {
      if (this.timeOffsetMS < 0) {
        return Date.now() + Math.abs(parseInt(this.timeOffsetMS || 0, 10));
      }
      return null;
    },

    displayCountdown() {
      if (!this.waitUntil) {
        return '';
      }

      const seconds = `00${Math.floor(this.countdown % 60)}`.slice(-2);
      const minutes = `00${Math.floor(this.countdown / 60)}`.slice(-2);
      return `${minutes}:${seconds}`;
    }
  },

  created() {
    if (!this.waitUntil) {
      this.timeoutId = setTimeout(this.getWebinarInfo, 20 * 1000);
    } else {
      this.tickCountdown();
    }
  },

  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },

  methods: {
    tickCountdown() {
      this.countdown = (this.waitUntil - Date.now()) / 1000;
      if (this.countdown > 0) {
        this.timeoutId = setTimeout(this.tickCountdown, 900);
      }
    },

    async getWebinarInfo() {
      clearTimeout(this.timeoutId);

      try {
        const webinarKey = this.$store.state.g2wWebinar.webinarInfo.webinarKey;
        const webinarInfo = await this.$store.dispatch('g2wWebinar/getWebinarInfoV2', {webinarKey});

        if (!webinarInfo.inSession) {
          this.timeoutId = setTimeout(this.getWebinarInfo, 20 * 1000);
        }
      } catch (error) {
        this.logger.error('cannot get webinar info', error);

        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(this.getWebinarInfo, 20 * 1000);
      }
    }
  }
};

export default Hallway;

</script>

<style lang="sass">
  @import 'src/scss/variables'
  @import 'src/scss/mixins'

  .hallway
    width: 100%
    height: 100%
    min-height: 250px
    text-align: center
    font-family: 'lato-bold'
    font-size: 30px
    color: $white
    background-image: url('../assets/wait.jpg')
    background-size: cover
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

    @include layout-vertical
      font-size: 24px

    p
      font-size: 1em
      margin: 0

    .message
      margin-bottom: 20px

    .starts-in
      font-family: lato-light
      font-size: .6em
      text-transform: uppercase

    .countdown
      font-size: 1.5em
</style>
